import * as React from 'react';
import './style.scss';

const HeroBanner = props => {
  return (
    <div className="hero-banner">
      <div className="container">
        <div
          className="content"
          data-sal="slide-up"
          data-sal-duration="1000"
          data-sal-delay="300"
          data-sal-easing="ease"
        >
          <h1>{props.title}</h1>
          {props.children}
        </div>
      </div>

      <div className="image">{props.photo}</div>
    </div>
  );
};

export default HeroBanner;
